export default {
    browser_title: "Kevi | UTM Automático",
    page_title: "UTM Automático",
    page_description:
        "Configure los parámetros UTM para que se agreguen automáticamente a los enlaces en las notificaciones.",
    success_message: "Actualizado con éxito",
    error_save: "Error al guardar",
    error_save_config: "Error al guardar la configuración",
    token_copied: "¡Token copiado con éxito!",
    toggle: {
        label: "Activar UTM Automático",
        hint: "Cuando está activado, los parámetros UTM se agregarán o reemplazarán automáticamente en todos los enlaces que se encuentren en las notificaciones.",
    },
    channels: {
        title: "Canales",
        description: "Seleccione en qué canales se aplicará el UTM automático:",
        email: "Correo electrónico",
        sms: "SMS",
        rcs: "RCS",
        whatsapp: "WhatsApp",
        whatsapp_cloud: "WhatsApp Cloud",
    },
    tokens: {
        title: "Tokens Disponibles",
        description:
            "Use estos tokens en los campos a continuación para personalizar los valores UTM:",
        copy: "Copiar",
    },
    params: {
        title: "Parâmetros UTM",
        description:
            "Configure los valores para cada parámetro UTM. Use los tokens de arriba para la personalización.",
        source: {
            label: "UTM Source",
            hint: "Identifica el origen del tráfico",
            placeholder: "Ej: [[nombre_automatizacion]]",
        },
        medium: {
            label: "UTM Medium",
            hint: "Identifica el medio de comunicación",
            placeholder: "Ej: [[canal]]",
        },
        campaign: {
            label: "UTM Campaign",
            hint: "Identifica la campaña específica",
            placeholder: "Ej: [[nombre_automatizacion]] - [[fecha]]",
        },
    },
    info: {
        important: "Importante:",
        description:
            "Si un enlace ya contiene parámetros UTM (utm_source, utm_medium, utm_campaign), serán reemplazados por los valores configurados aquí.",
    },
    actions: {
        save: "Guardar Configuración",
    },
};
